import { Box, Skeleton, Stack, useTheme, alpha } from "@mui/material";

const AuthLoading = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: theme.palette.background.default,
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 400, px: 3 }}>
        <Stack spacing={3}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  border: `3px solid ${theme.palette.primary.main}`,
                  borderTopColor: "transparent",
                  animation: "spin 0.8s linear infinite",
                  "@keyframes spin": {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              />
            </Box>
          </Box>
          <Skeleton
            variant="rounded"
            width="60%"
            height={40}
            sx={{ mx: "auto", bgcolor: alpha(theme.palette.text.primary, 0.08) }}
          />
          <Skeleton
            variant="rounded"
            width="100%"
            height={56}
            sx={{ bgcolor: alpha(theme.palette.text.primary, 0.06) }}
          />
          <Skeleton
            variant="rounded"
            width="100%"
            height={56}
            sx={{ bgcolor: alpha(theme.palette.text.primary, 0.06) }}
          />
          <Skeleton
            variant="rounded"
            width="100%"
            height={42}
            sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1) }}
          />
        </Stack>
      </Box>
    </Box>
  );
};

export default AuthLoading;